export default "__VITE_ASSET__C7b_yQEH__"